// extracted by mini-css-extract-plugin
module.exports = {"callRoomModal":"_2SJeN","placeholder":"_2E3DN"};